import {appInstance} from '@/utils/app-accessor'
import {postMessageLoad} from '@/utils/worker-helpers'
// @ts-ignore
import {axiosInstance} from '@/utils/axios-accessor'
import {later} from '@/utils/helpers'
import {addSeconds} from 'date-fns'
import type {Ref} from 'vue'

export const partialSearchRequest = ({searchKey}: any) => ({searchKey})

export const initSliderFilter = (
    initialValue: any[],
    selectedValue: any[],
    responseValue: any[],
    key: string,
    mutation: (arg0: {key: any; value: any}) => void
) => {
    const value = selectedValue.slice()
    if (initialValue[0] === selectedValue[0] || selectedValue[0] === 0) {
        value[0] = responseValue[0]
    }
    if (initialValue[1] === selectedValue[1] || selectedValue[1] === Infinity) {
        value[1] = responseValue[1]
    }
    if (selectedValue[0] !== value[0] || selectedValue[1] !== value[1]) {
        mutation({key, value})
    }
}

export const setSliderFilter = (searchResponse: any, productStore: any, key: string) => {
    initSliderFilter(
        productStore.searchResponse.filters[key],
        productStore.filters[key],
        searchResponse.filters[key],
        key,
        productStore.SET_FILTER
    )
}

const setSearchResponse = (
    searchResponse: any,
    productName: string,
    productStore: any,
    srOffersKey: string,
    sliderFilters: any
) => {
    if (productStore.searchResponse[srOffersKey].length !== searchResponse[srOffersKey].length) {
        sliderFilters.forEach((key: string) => {
            setSliderFilter(searchResponse, productStore, key)
        })
        const offers = searchResponse[srOffersKey],
            sr = {...searchResponse}
        //TODO Change to offersCount with api transformer
        sr[srOffersKey] = new Array(offers.length)
        productStore.SET_SEARCH_RESPONSE(sr)
        appInstance.$localForage.setItem(productName, offers)
        postMessageLoad(productName, productStore, offers)
    }
}

export async function partialSearch(
    SET_PARTIAL_SEARCH_RESULTS_CTS: Function,
    SET_PARTIAL_SEARCH_TIMEOUT_INSTANCE: Function,
    partialSearchTimeoutInstance: Ref,
    searchRequest: any,
    productName: string,
    productStore: any,
    apiProductSearch: any,
    srOffersKey = 'product',
    sliderFilters = ['price']
) {
    const {searchKey} = await apiProductSearch.get(searchRequest)
    let searchResponse
    do {
        try {
            // @ts-ignore
            const cancelTokenSource = axiosInstance.CancelToken.source()
            SET_PARTIAL_SEARCH_RESULTS_CTS(cancelTokenSource)
            const {offersCount, processed} = await appInstance.$api.partialSearchStatus.get({searchKey})
            //TODO Need the same search RS structure for all products
            if (
                (
                    productStore.searchResponse.offers ||
                    productStore.searchResponse.product ||
                    productStore.searchResponse.products
                ).length === offersCount
            ) {
                // @ts-ignore
                SET_PARTIAL_SEARCH_TIMEOUT_INSTANCE(later(appInstance.$conf.public.search.partialResponseInterval))
                await partialSearchTimeoutInstance.value.promise
                searchResponse = {processed}
                if (!processed) continue
            }
            searchResponse = await appInstance.$api.partialSearchResults.get(
                {searchKey, product: productName, ...searchRequest},
                cancelTokenSource.token
            )
            setSearchResponse(searchResponse, productName, productStore, srOffersKey, sliderFilters)
        } catch (e: any) {
            if (!e) {
                break
            } else if (e.status === 404) {
                //TODO Check 404 - searchKey has expired
                await partialSearch(
                    SET_PARTIAL_SEARCH_RESULTS_CTS,
                    SET_PARTIAL_SEARCH_TIMEOUT_INSTANCE,
                    partialSearchTimeoutInstance,
                    searchRequest,
                    productName,
                    productStore,
                    apiProductSearch,
                    srOffersKey,
                    sliderFilters
                )
                return
            } else {
                throw e
            }
        }
    } while (!searchResponse.processed)
    if (searchResponse[srOffersKey].length) {
        productStore.SET_SEARCH_EXPIRATION_TIME(addSeconds(new Date(), appInstance.$conf.public.search.offersLifetime))
    }
}

export async function search(
    SET_PARTIAL_SEARCH_RESULTS_CTS: Function,
    searchRequest: any,
    productName: string,
    productStore: any,
    apiProductSearch: any,
    srOffersKey = 'product',
    sliderFilters = ['price']
) {
    // @ts-ignore
    const cancelTokenSource = axiosInstance.CancelToken.source()
    SET_PARTIAL_SEARCH_RESULTS_CTS(cancelTokenSource)
    //TODO Add cancel token to request
    const searchResponse = await apiProductSearch.get(searchRequest)
    setSearchResponse(searchResponse, productName, productStore, srOffersKey, sliderFilters)
    if (searchResponse[srOffersKey].length) {
        productStore.SET_SEARCH_EXPIRATION_TIME(addSeconds(new Date(), appInstance.$conf.public.search.offersLifetime))
    }
}

export function newSearch(
    stopSearch: Function,
    SET_OFFERS: Function,
    searchRequest: any,
    blankSearchResponse: any,
    productStore: any
) {
    stopSearch()
    SET_OFFERS([])
    productStore.SET_SEARCH_RESPONSE(blankSearchResponse)
    productStore.NEW_SEARCH(searchRequest)
}
